import React from 'react'
import Form from 'react-bootstrap/Form';
import PropTypes from 'prop-types';

export default function UiShareEmailInput(props) {


    return (
        <>
            <div className='sb-share-email-input'>
                <Form.Group>
                    <Form.Control
                        type="text"
                        placeholder={props.placeholder}
                        value={props.value}
                    />
                     <Form.Control.Feedback type={props.errorType}>
                        {props.errorMsg}
                    </Form.Control.Feedback>
                </Form.Group>
            </div>

        </>
    )
}

UiShareEmailInput.propTypes = {
    placeholder: PropTypes.string,
    value: PropTypes.string,
    errorMsg: PropTypes.string,
    errorType:PropTypes.string
};